import { DatePipe } from '@angular/common'
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { OrderDetailActionsComponent } from '@spartacus/order/components'
import { Observable, Subscription } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { EbLanguageService } from '../../../site-context/services/eb-language.service'
import { EbDelivery } from '../../interfaces/eb-order.interface'
import { EbOrderDetailsService } from '../../services/facades/eb-order-details.service'
import {EbOrderHistoryService} from "../../services/facades/eb-order-history.service";

@Component({
    selector: 'eb-order-detail-items',
    templateUrl: './eb-order-detail-items.component.html',
    styleUrls: ['./eb-order-detail-items.component.scss'],
    standalone: false
})
export class EbOrderDetailItemsComponent
  extends OrderDetailActionsComponent
  implements OnInit, OnDestroy
{
  sortedDeliveries: EbDelivery[]

  private readonly subscriptions = new Subscription()
  constructor(
    protected orderDetailsService: EbOrderDetailsService,
    protected languageService: EbLanguageService,
    protected cd: ChangeDetectorRef,
    protected ebOrderHistoryService: EbOrderHistoryService,
  ) {
    super(orderDetailsService)
  }

  ngOnInit() {
    this.subscriptions.add(
      this.ebOrderHistoryService.getOrderDetails().subscribe(order => {
        if (order.deliveries) {
          this.sortedDeliveries = this.sortDeliveryByDate(order.deliveries)
          this.cd.detectChanges()
        }
      })
    )
  }

  sortDeliveryByDate(deliveries) {
    const sortedDeliveries = JSON.parse(JSON.stringify(deliveries))
    return sortedDeliveries?.sort((firstDate, secondDate) => {
      let firstDateToTime = new Date(firstDate.goodsIssueDate).getTime()
      let secondDateToTime = new Date(secondDate.goodsIssueDate).getTime()
      // needed to place unknown shipping-date deliveries between open and completed deliveries
      if (!firstDateToTime && secondDateToTime) {
        firstDateToTime = this.handleUnknownShipmentDates(secondDateToTime)
      } else if (firstDateToTime && !secondDateToTime) {
        secondDateToTime = this.handleUnknownShipmentDates(firstDateToTime)
      }
      return secondDateToTime - firstDateToTime
    })
  }

  isAlreadyDelivered(dateTimeString): boolean {
    return new Date().getTime() >= dateTimeString
  }

  handleUnknownShipmentDates(dateToTimeString): number {
    return this.isAlreadyDelivered(dateToTimeString) ? dateToTimeString + 1 : dateToTimeString - 1
  }

  getFormattedDate(goodsIssueDate): Observable<string> {
    const date = new Date(goodsIssueDate)
    return this.languageService.getActive().pipe(
      take(1),
      map(activeLanguage => new DatePipe(activeLanguage).transform(date))
    )
  }

  getDeliveryTitle(delivery): string {
    if (this.isAlreadyDelivered(new Date(delivery?.goodsIssueDate).getTime())) {
      return 'isAlreadyDeliveredTitle'
    } else if (!delivery?.goodsIssueDate) {
      return 'noGoodsIssueDateAvailable'
    } else {
      return 'isNotYetDeliveredTitle'
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
